import api from '@/services/api'

export const getLastCheckInFromApi = async (targetId, type) => {
    try {
        const prefix = type === 'target' ? 'goals' : 'kpi'
        const resp = api.get(`/${prefix}/${targetId}/checkins/get-last-checkin`)
        return resp
    } catch (e) {
        console.log(e)
    }
}

export const getCheckInFromApi = async (
    indicatorId,
    checkinId,
    indicatorType
) => {
    try {
        if (indicatorType == 'target') {
            const resp = await getTargetCheckinFromApi(indicatorId, checkinId)
            return resp
        } else if (indicatorType == 'kpi') {
            const resp = await getKpiCheckinFromApi(indicatorId, checkinId)
            return resp
        }
    } catch (e) {
        console.log(e)
    }
}

function getTargetCheckinFromApi(targetId, checkinId) {
    return api.get(`/goals/${targetId}/checkins/${checkinId}`)
}
function getKpiCheckinFromApi(kpiId, checkinId) {
    return api.get(`/kpi/${kpiId}/checkins/${checkinId}`)
}

export const setCurrentCheckin = async (indicatorId, form, indicatorType) => {
    try {
        if (indicatorType == 'target') {
            const resp = await setTargetCurrentCheckin(indicatorId, form)
            return resp
        } else if (indicatorType == 'kpi') {
            const resp = await setKpiCurrentCheckin(indicatorId, form)
            return resp
        }
    } catch (e) {
        console.log(e)
    }
}

function setTargetCurrentCheckin(targetId, form) {
    return api.post(`/goals/${targetId}/checkins`, form)
}

function setKpiCurrentCheckin(kpiId, form) {
    return api.post(`/kpi/${kpiId}/checkins`, form)
}

export const updateCheckIn = async (
    indicatorId,
    checkinId,
    form,
    indicatorType
) => {
    try {
        if (indicatorType == 'target') {
            const resp = await updateTargetCheckin(indicatorId, checkinId, form)
            return resp
        } else if (indicatorType == 'kpi') {
            const resp = await updateKpiCheckin(indicatorId, checkinId, form)
            return resp
        }
    } catch (e) {
        console.log(e)
    }
}

function updateTargetCheckin(targetId, checkinId, form) {
    return api.put(`/goals/${targetId}/checkins/${checkinId}`, form)
}

function updateKpiCheckin(kpiId, checkinId, form) {
    return api.put(`/kpi/${kpiId}/checkins/${checkinId}`, form)
}

export const getRangesFromAPI = async () => {
    try {
        const resp = await api.get('/ranges', {
            params: {
                all: 1,
                ascending: 1,
                orderBy: 'order',
            },
        })
        return resp
    } catch (e) {
        console.log(e)
    }
}
